import {Separator} from '@common-web/components/ui/separator';
import {ContactFields} from '../components/ContactFields';

export function Section125Contacts() {
  return (
    <div className='space-y-6'>
      <div>
        <ContactFields
          basePath={'section125Form.contacts.authorizedSigner'}
          titlePrefix={'Authorized Signer (Plan Administrator)'}
          requiredFields={['firstName', 'lastName', 'email']}
          copySources={[
            {label: 'Eligibility Contact', path: 'section125Form.contacts.eligibilityContact'},
            {label: 'Billing Contact', path: 'section125Form.contacts.billingContact'},
          ]}
        />
      </div>
      <Separator />
      <div>
        <ContactFields
          basePath={'section125Form.contacts.eligibilityContact'}
          titlePrefix={'Eligibility Contact (Optional)'}
          copySources={[
            {
              label: 'Same as Plan Administrator (Authorized Signer)',
              path: 'section125Form.contacts.authorizedSigner',
            },
            {label: 'Billing Contact', path: 'section125Form.contacts.billingContact'},
          ]}
        />
      </div>
      <Separator />
      <div>
        <ContactFields
          basePath={'section125Form.contacts.billingContact'}
          titlePrefix={'Billing Contact'}
          requiredFields={['firstName', 'lastName', 'email']}
          copySources={[
            {
              label: 'Same as Plan Administrator (Authorized Signer)',
              path: 'section125Form.contacts.authorizedSigner',
            },
            {label: 'Eligibility Contact', path: 'section125Form.contacts.eligibilityContact'},
          ]}
        />
      </div>
    </div>
  );
}
